import type { RouteRecordRaw } from 'vue-router'

// 服务商平台独立路由配置
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('./VendorPlatform.vue'),
    redirect: '/overview',
    children: [
      // 首页
      {
        path: 'overview',
        name: 'VendorOverview',
        component: () => import('./pages/Overview.vue'),
        meta: { title: '工作台总览', icon: 'dashboard', permissions: ['*:platform_vendor:*:view'] }
      },
      // GEO增长
      {
        path: 'geo',
        name: 'VendorGeo',
        component: () => import('./pages/GeoOverview.vue'),
        meta: { title: 'GEO增长', icon: 'geo', permissions: ['*:platform_vendor:geo:view'] }
      },
      {
        path: 'geo/opportunities',
        name: 'VendorGeoOpportunities',
        component: () => import('./pages/GeoOpportunities.vue'),
        meta: { title: '增长机会', icon: 'geo', permissions: ['*:platform_vendor:geo:view'] }
      },
      {
        path: 'geo/hotwords',
        name: 'VendorGeoHotwords',
        component: () => import('./pages/GeoHotwords.vue'),
        meta: { title: '热门关键词', icon: 'geo', permissions: ['*:platform_vendor:geo:view'] }
      },
      {
        path: 'geo/ranking',
        name: 'VendorGeoRanking',
        component: () => import('./pages/GeoRanking.vue'),
        meta: { title: '排名分析', icon: 'geo', permissions: ['*:platform_vendor:geo:view'] }
      },
      {
        path: 'geo/ecosystem',
        name: 'VendorGeoEcosystem',
        component: () => import('./pages/GeoEcosystem.vue'),
        meta: { title: '生态分析', icon: 'geo', permissions: ['*:platform_vendor:geo:view'] }
      },
      {
        path: 'geo/diagnosis',
        name: 'VendorGeoDiagnosis',
        component: () => import('./pages/GeoDiagnosisTools.vue'),
        meta: { title: '诊断工具', icon: 'geo', permissions: ['*:platform_vendor:geo:view'] }
      },
      // 诊断服务（企业主诊断管理）
      {
        path: 'diagnosis',
        name: 'VendorDiagnosisOverview',
        component: () => import('./pages/DiagnosisOverview.vue'),
        meta: { title: '诊断服务', icon: 'diagnosis', permissions: ['*:platform_vendor:diagnosis:view'] }
      },
      {
        path: 'diagnosis/tasks',
        name: 'VendorDiagnosisTasks',
        component: () => import('./pages/DiagnosisTaskList.vue'),
        meta: { title: '诊断任务', icon: 'diagnosis', permissions: ['*:platform_vendor:diagnosis:view'] }
      },
      {
        path: 'diagnosis/review',
        name: 'VendorDiagnosisReview',
        component: () => import('./pages/ReviewManage.vue'),
        meta: { title: '校验管理', icon: 'diagnosis', permissions: ['*:platform_vendor:diagnosis:view'] }
      },
      // 企业管理
      {
        path: 'businesses',
        name: 'VendorBusinesses',
        component: () => import('./pages/BusinessList.vue'),
        meta: { title: '企业列表', icon: 'businesses', permissions: ['*:platform_vendor:business:view'] }
      },
      {
        path: 'businesses/:id',
        name: 'VendorBusinessDetail',
        component: () => import('./pages/BusinessDetail.vue'),
        meta: { title: '企业详情', icon: 'businesses', permissions: ['*:platform_vendor:business:view'] }
      },
      // 我的团队
      {
        path: 'team',
        name: 'VendorTeam',
        component: () => import('./pages/TeamList.vue'),
        meta: { title: '成员列表', icon: 'team', permissions: ['*:platform_vendor:team:view'] }
      },
      {
        path: 'team/:id',
        name: 'VendorTeamDetail',
        component: () => import('./pages/TeamDetail.vue'),
        meta: { title: '成员详情', icon: 'team', permissions: ['*:platform_vendor:team:view'] }
      },
      {
        path: 'team/task-assign',
        name: 'VendorTaskAssign',
        component: () => import('./pages/TaskAssign.vue'),
        meta: { title: '任务指派', icon: 'team', permissions: ['*:platform_vendor:team:view'] }
      },
      {
        path: 'business/request/accept',
        name: 'VendorRequestAccept',
        component: () => import('./pages/RequestAccept.vue'),
        meta: { title: '需求承接', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      {
        path: 'business/request/reject/:id',
        name: 'VendorRequestReject',
        component: () => import('./pages/RequestReject.vue'),
        meta: { title: '退回处理', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      {
        path: 'task/project/:id',
        name: 'VendorProjectView',
        component: () => import('./pages/ProjectView.vue'),
        meta: { title: '项目视图', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      // 支持任务
      {
        path: 'tasks',
        name: 'VendorTasks',
        component: () => import('./pages/SupportTaskList.vue'),
        meta: { title: '企业需求列表', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      {
        path: 'tasks/:id',
        name: 'VendorTaskDetail',
        component: () => import('./pages/RequestDetail.vue'),
        meta: { title: '任务详情', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      {
        path: 'todolist',
        name: 'VendorTodoList',
        component: () => import('./pages/TodoList.vue'),
        meta: { title: '待办事项', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      {
        path: 'todolist/:id',
        name: 'VendorTodoDetail',
        component: () => import('./pages/TodoDetail.vue'),
        meta: { title: '待办详情', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      // 企业任务中心（查看企业客户全量任务）
      {
        path: 'business-tasks',
        name: 'VendorBusinessTaskCenter',
        component: () => import('./pages/BusinessTaskCenter.vue'),
        meta: { title: '企业任务中心', icon: 'tasks', permissions: ['*:platform_vendor:task:view'] }
      },
      // 工具中心
      {
        path: 'tools',
        name: 'VendorTools',
        component: () => import('./pages/QuickTools.vue'),
        meta: { title: '快捷工具', icon: 'tools', permissions: ['*:platform_vendor:tool:view'] }
      },
      {
        path: 'tools/square',
        name: 'VendorToolsSquare',
        component: () => import('./pages/ToolsSquare.vue'),
        meta: { title: '工具广场', icon: 'tools', permissions: ['*:platform_vendor:tool:view'] }
      },
      {
        path: 'tools/advanced',
        name: 'VendorToolsAdvanced',
        component: () => import('./pages/AdvancedTools.vue'),
        meta: { title: '高级工具集', icon: 'tools', permissions: ['*:platform_vendor:tool:view'] }
      },
      {
        path: 'tools/detail/:id',
        name: 'VendorToolDetail',
        component: () => import('./pages/ToolDetail.vue'),
        meta: { title: '工具详情', icon: 'tools', permissions: ['*:platform_vendor:tool:view'] }
      },
      {
        path: 'ai-assistant',
        name: 'VendorAIAssistant',
        component: () => import('./pages/AIAssistant.vue'),
        meta: { title: 'AI助手', icon: 'ai', permissions: ['*:platform_vendor:tool:view'] }
      },
      {
        path: 'snapshot',
        name: 'VendorSnapshot',
        component: () => import('./pages/Snapshot.vue'),
        meta: { title: '快照工具', icon: 'snapshot', permissions: ['*:platform_vendor:tool:view'] }
      },
      // 技术对接
      {
        path: 'tech',
        name: 'VendorTech',
        component: () => import('./pages/TechConfig.vue'),
        meta: { title: '基础配置', icon: 'tech', permissions: ['*:platform_vendor:tech:view'] }
      },
      {
        path: 'tech/center',
        name: 'VendorTechCenter',
        component: () => import('./pages/TechCenter.vue'),
        meta: { title: '技术对接中心', icon: 'tech', permissions: ['*:platform_vendor:tech:view'] }
      },
      // 推广中心
      {
        path: 'promotion',
        name: 'VendorPromotion',
        component: () => import('./pages/PromotionTask.vue'),
        meta: { title: '推广任务', icon: 'promotion', permissions: ['*:platform_vendor:promotion:view'] }
      },
      {
        path: 'promotion/material',
        name: 'VendorPromotionMaterial',
        component: () => import('./pages/PromotionMaterial.vue'),
        meta: { title: '推广素材', icon: 'promotion', permissions: ['*:platform_vendor:promotion:view'] }
      },
      {
        path: 'promotion/track',
        name: 'VendorPromotionTrack',
        component: () => import('./pages/PromotionTrack.vue'),
        meta: { title: '推广跟踪', icon: 'promotion', permissions: ['*:platform_vendor:promotion:view'] }
      },
      {
        path: 'promotion/report',
        name: 'VendorPromotionReport',
        component: () => import('./pages/PromotionReport.vue'),
        meta: { title: '效果报表', icon: 'promotion', permissions: ['*:platform_vendor:promotion:view'] }
      },
      // 数据分析
      {
        path: 'analytics',
        name: 'VendorAnalytics',
        component: () => import('./pages/ServiceReport.vue'),
        meta: { title: '服务报表', icon: 'analytics', permissions: ['*:platform_vendor:analytics:view'] }
      },
      {
        path: 'analytics/service',
        name: 'VendorAnalyticsService',
        component: () => import('./pages/AnalyticsTeam.vue'),
        meta: { title: '团队报表', icon: 'analytics', permissions: ['*:platform_vendor:analytics:view'] }
      },
      {
        path: 'analytics/standard',
        name: 'VendorAnalyticsStandard',
        component: () => import('./pages/AnalyticsStandard.vue'),
        meta: { title: '标准报表', icon: 'analytics', permissions: ['*:platform_vendor:analytics:view'] }
      },
      {
        path: 'analytics/deep',
        name: 'VendorAnalyticsDeep',
        component: () => import('./pages/AnalyticsDeep.vue'),
        meta: { title: '深度分析', icon: 'analytics', permissions: ['*:platform_vendor:analytics:view'] }
      },
      // 充值与消耗
      {
        path: 'billing',
        name: 'VendorBilling',
        component: () => import('./pages/AccountOverview.vue'),
        meta: { title: '账户总览', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      {
        path: 'billing/recharge',
        name: 'VendorBillingRecharge',
        component: () => import('./pages/BillingRecharge.vue'),
        meta: { title: '充值', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      {
        path: 'billing/consume',
        name: 'VendorBillingConsume',
        component: () => import('./pages/BillingConsume.vue'),
        meta: { title: '消耗明细', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      {
        path: 'billing/plan',
        name: 'VendorBillingPlan',
        component: () => import('./pages/BillingPlan.vue'),
        meta: { title: '套餐管理', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      {
        path: 'billing/commission',
        name: 'VendorBillingCommission',
        component: () => import('./pages/BillingCommission.vue'),
        meta: { title: '佣金收益', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      {
        path: 'billing/business',
        name: 'VendorBillingBusiness',
        component: () => import('./pages/BillingBusiness.vue'),
        meta: { title: '企业消耗', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      {
        path: 'billing/contract',
        name: 'VendorBillingContract',
        component: () => import('./pages/BillingContract.vue'),
        meta: { title: '协议备份', icon: 'billing', permissions: ['*:platform_vendor:billing:view'] }
      },
      // 账户设置
      {
        path: 'settings',
        name: 'VendorSettings',
        component: () => import('./pages/AccountSettings.vue'),
        meta: { title: '企业信息', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      {
        path: 'settings/team',
        name: 'VendorSettingsTeam',
        component: () => import('./pages/TeamPerformance.vue'),
        meta: { title: '团队信息', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      {
        path: 'settings/capability',
        name: 'VendorSettingsCapability',
        component: () => import('./pages/SettingsCapability.vue'),
        meta: { title: '能力中心', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      {
        path: 'settings/notification',
        name: 'VendorSettingsNotification',
        component: () => import('./pages/SettingsNotification.vue'),
        meta: { title: '消息通知', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      {
        path: 'settings/security',
        name: 'VendorSettingsSecurity',
        component: () => import('./pages/SettingsSecurity.vue'),
        meta: { title: '安全设置', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      {
        path: 'settings/company',
        name: 'VendorSettingsCompany',
        component: () => import('./pages/SettingsCompany.vue'),
        meta: { title: '企业信息', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      {
        path: 'settings/permission',
        name: 'VendorSettingsPermission',
        component: () => import('./pages/SettingsPermission.vue'),
        meta: { title: '权限管理', icon: 'settings', permissions: ['*:platform_vendor:settings:view'] }
      },
      // 其他
      {
        path: 'help',
        name: 'VendorHelp',
        component: () => import('./pages/OthersHelp.vue'),
        meta: { title: '帮助中心', icon: 'help', permissions: ['*:platform_vendor:*:view'] }
      },
      {
        path: 'about',
        name: 'VendorAbout',
        component: () => import('./pages/OthersAbout.vue'),
        meta: { title: '关于我们', icon: 'help', permissions: ['*:platform_vendor:*:view'] }
      },
      {
        path: 'feedback',
        name: 'VendorFeedback',
        component: () => import('./pages/OthersFeedback.vue'),
        meta: { title: '意见反馈', icon: 'help', permissions: ['*:platform_vendor:*:view'] }
      }
    ]
  }
]

export const vendorSiteRoutes = routes

export default routes
